module.exports = __webpack_public_path__ + "static/media/projectors.2cc6ea52.svg";